// Adapted from pinpointedu/frontend/apps/product/src/next/app/navigation/destinations.ts.
// Three primary tabs, per §3 of the frontend proposal. There is no Home
// destination: `/` redirects to `/accounts`.
export type PrimaryDestination = 'accounts' | 'transactions' | 'business';

export const PRIMARY_DESTINATIONS: PrimaryDestination[] = ['accounts', 'transactions', 'business'];

const PRIMARY_DESTINATION_HREFS = {
  accounts: '/accounts',
  transactions: '/transactions',
  business: '/business',
} as const satisfies Record<PrimaryDestination, `/${PrimaryDestination}`>;

const PRIMARY_DESTINATION_LABELS: Record<PrimaryDestination, string> = {
  accounts: 'Accounts',
  transactions: 'Transactions',
  business: 'Business',
};

export function primaryDestinationHref(destination: PrimaryDestination): `/${PrimaryDestination}` {
  return PRIMARY_DESTINATION_HREFS[destination];
}

export function primaryDestinationLabel(destination: PrimaryDestination): string {
  return PRIMARY_DESTINATION_LABELS[destination];
}
